import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(apiListener);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { race, call, put, takeEvery, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import isString from 'lodash/isString';
import mapValues from 'lodash/mapValues';
import { fetchDedupe } from 'fetch-dedupe';
import { AuthError, FetchError, UnauthorizedError } from '@signal/utils/errors';
import { authFailure } from '../auth';
import { API_REQUEST } from '../root-constants';
import { isExternalRequest, isSignalMicroserviceRequest } from './utils';
import { API_URL, API_METHODS } from './constants';
export function createApiRequestHandler() {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(authorizedFetch);
  /**
   * The authorizedFetch saga abstracts away some of the inherent complexity of
   * calling our API endpoints. It will automatically handle refreshing the auth
   * token, adding the `Authorization` header, and de-duping requests that are
   * the same.
   *
   * @param {String} url - the url OR signal endpoint to hit (ex. `/insights`)
   * @param {Object} options - options to pass to fetch
   */


  function authorizedFetch(url) {
    var options,
        responseType,
        _options$timeout,
        timeout,
        requestOptions,
        dedupeOptions,
        isExternal,
        _requestOptions,
        _requestOptions$heade,
        headers,
        rest,
        noUndefinedHeaders,
        response,
        _yield$race,
        _args = arguments;

    return _regeneratorRuntime.wrap(function authorizedFetch$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            responseType = options.responseType, _options$timeout = options.timeout, timeout = _options$timeout === void 0 ? 150000 : _options$timeout, requestOptions = _objectWithoutProperties(options, ["responseType", "timeout"]); // Options passed through to `fetch-dedupe`

            dedupeOptions = {
              responseType: responseType
            }; // Checks if provided `url` starts with 'http' to determine if request is
            // for an internal API endpoint

            isExternal = isExternalRequest(url); // If the provided `url` is an internal API endpoint, we enhance the request
            // with Signal authorization headers

            if (!isExternal) {
              _requestOptions = requestOptions, _requestOptions$heade = _requestOptions.headers, headers = _requestOptions$heade === void 0 ? {} : _requestOptions$heade, rest = _objectWithoutProperties(_requestOptions, ["headers"]); // When sending form data the user should not set Content-Type, so to achieve
              // sending no Content-Type and still have the backwards compatible feature of
              // setting application/json as default the user can set Content-Type to undefined
              // and it will be removed from the header object that is passed to fetch api

              noUndefinedHeaders = JSON.parse(JSON.stringify(_objectSpread({
                'Content-Type': 'application/json'
              }, headers))); // Enhance request with Signal authorization headers

              requestOptions = _objectSpread(_objectSpread({}, rest), {}, {
                credentials: 'include',
                headers: noUndefinedHeaders
              }); // Prefix the provided endpoint with the Signal API base url

              if (!isSignalMicroserviceRequest(url)) url = "".concat(API_URL).concat(url);
            }

            _context.prev = 5;
            ;
            _context.next = 9;
            return race({
              response: call(fetchDedupe, url, requestOptions, dedupeOptions),
              timeout: delay(timeout)
            });

          case 9:
            _yield$race = _context.sent;
            response = _yield$race.response;
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);
            throw new FetchError('an unexpected error occurred');

          case 16:
            if (response) {
              _context.next = 18;
              break;
            }

            throw new FetchError('request timeout');

          case 18:
            if (!response.ok) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return", response.data);

          case 20:
            if (isExternal) {
              _context.next = 28;
              break;
            }

            _context.t1 = response.status;
            _context.next = _context.t1 === 401 ? 24 : _context.t1 === 403 ? 27 : 28;
            break;

          case 24:
            _context.next = 26;
            return put(authFailure('Unauthorized, please re-authenticate'));

          case 26:
            throw new AuthError();

          case 27:
            throw new UnauthorizedError(response.statusText);

          case 28:
            throw new FetchError(response);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _marked, null, [[5, 13]]);
  }
  /**
   * Return a saga that wraps automatically adds the correct method type
   * and JSON stringifies the body (if present and not already stringified).
   */


  function createApiRequestSaga(method) {
    return /*#__PURE__*/_regeneratorRuntime.mark(function baseApiRequest(_ref) {
      var actions, url, options, payloadReducers, cacheBust, _options, body, _payloadReducers, requestReducer, successReducer, failureReducer, requestPayload, successPayload, failurePayload;

      return _regeneratorRuntime.wrap(function baseApiRequest$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              actions = _ref.actions, url = _ref.url, options = _ref.options, payloadReducers = _ref.payloadReducers, cacheBust = _ref.cacheBust;
              payloadReducers = payloadReducers || {};
              options = options || {};
              _options = options, body = _options.body;
              _payloadReducers = payloadReducers, requestReducer = _payloadReducers.request, successReducer = _payloadReducers.success, failureReducer = _payloadReducers.failure; // Conveniently convert body to JSON if it is not already converted.

              if (body) {
                options.body = isString(body) || body instanceof FormData // Do not stringify strings or FormData
                ? body : JSON.stringify(body);
              }

              if (method) {
                options.method = method;
              }

              if (cacheBust) {
                url += "".concat(url.includes('?') ? '&' : '?', "cache_bust=").concat(Date.now());
              }

              requestPayload = null;
              if (requestReducer) requestPayload = requestReducer({
                options: options,
                url: url
              });
              _context2.next = 12;
              return put(actions.request(requestPayload));

            case 12:
              _context2.prev = 12;
              _context2.next = 15;
              return call(authorizedFetch, url, options);

            case 15:
              successPayload = _context2.sent;
              if (successReducer) successPayload = successReducer(successPayload);
              _context2.next = 19;
              return put(actions.success(successPayload));

            case 19:
              _context2.next = 27;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](12);
              failurePayload = _context2.t0;
              if (failureReducer) failurePayload = failureReducer(failurePayload);
              _context2.next = 27;
              return put(actions.failure(failurePayload));

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, baseApiRequest, null, [[12, 21]]);
    });
  }

  var apiRequestSagas = mapValues(API_METHODS, function (method) {
    return createApiRequestSaga(method);
  });
  return /*#__PURE__*/_regeneratorRuntime.mark(function handleApiRequest(_ref2) {
    var payload, meta, method;
    return _regeneratorRuntime.wrap(function handleApiRequest$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            payload = _ref2.payload, meta = _ref2.meta;
            method = meta.method;
            _context3.next = 4;
            return call(apiRequestSagas[method], payload);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, handleApiRequest);
  });
}
export var matchApiRequest = function matchApiRequest(action) {
  return get(action, ['meta', API_REQUEST]);
};
export function apiListener() {
  var handleApiRequest;
  return _regeneratorRuntime.wrap(function apiListener$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call(createApiRequestHandler);

        case 2:
          handleApiRequest = _context4.sent;
          _context4.next = 5;
          return takeEvery(matchApiRequest, handleApiRequest);

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked2);
}